<template>
    <BreadCrumb PageTitle="Paiement par virement" />
    <AddVirement />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddVirement from "../../components/Virement/AddVirement.vue";
    export default defineComponent({
      name: "AddVirementPage",
      components: {
        BreadCrumb,
        AddVirement,
      },
    });
  </script>